import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { deleteData, getData, patchData, postData } from "src/utils/axios/serverHelper";
import { formatDate } from "src/utils/string/stringUtil";
import { PRD3020_R01DetailDto, PRD3020_R01Dto } from "./Dto_PRD3020_R01";
import { PRD3020_R01Filter } from "./Store_PRD3020_R01";

const baseUrl = `${config.apiUrl}/PRD3020_R01`;

const getParams = (filter: Partial<PRD3020_R01Filter>, listLength?: number) => {
	return {
		compCd: filter.compCd,
		workplaceCd: filter.workplaceCd,
		jobTeam: filter.jobTeam,
		startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
		endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
		closeTag: filter.closeTag,
		listLength: listLength || 0
	}
}

export const getPRD3020_R01List = async (option: string, params: Partial<PRD3020_R01Filter>, listLength: number = 0) => {
    const url = `${baseUrl}/${option}`

    return await getData<ResponseDto<PRD3020_R01Dto[]>>(url, { params: getParams(params, listLength) });
}

export const getPRD3020_R01DetailList = async (params: Partial<PRD3020_R01Filter>) => {
    const url = `${baseUrl}/detail`;

    return await getData<ResponseDto<PRD3020_R01DetailDto[]>>(url, { params: getParams(params, 0) });
}

export const getPRD3020_R01AllCount = async (params: Partial<PRD3020_R01Filter>) => {
    const url = `${baseUrl}/allCount`;
    return await getData<ResponseDto<number>>(url, { params: getParams(params, 0) });
}

export const postPRD3020_R01 = async (data: PRD3020_R01Dto) => {
    const url = `${baseUrl}`;

    return await postData<PRD3020_R01Dto, ResponseDto<PRD3020_R01Dto>>(url, data);
}

export const patchPRD3020_R01 = async (data: PRD3020_R01Dto) => {
    const url = `${baseUrl}`;

    return await patchData<PRD3020_R01Dto, ResponseDto<PRD3020_R01Dto>>(url, data);
}

export const deletePRD3020_R01 = async (userId: string) => {
    let url = `${baseUrl}/${userId}`;

    return await deleteData<ResponseDto<any>>(url);
}

export const downloadExcel_PRD3020_R01 = async (option: string, params: Partial<PRD3020_R01Filter>, listLength: number = 0) => {
    const url = `${baseUrl}/excel/${option}`

    return await getData<ResponseDto<string>>(url, { params: getParams(params, listLength) });
}
